module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "page"
  }, [_c('page-header', {
    attrs: {
      "header": _vm.title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('newsfeed')], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66c721c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/News.vue
// module id = 380
// module chunks = 0